import env from 'environments';

export const hasTripwireReportAccess = () => {
  return env.FEATURE_TRIPWIRE_REPORT;
};
